import { handleQuickViewClickAnalytics, getProdvmFromDatabridge } from '@xp-utilities/web';

export const handleOnRecommendedProductClick = (
  isNewQuickviewEnabled,
  event,
  product,
) => {
  const {
    brand,
    collection,
    faceout,
    id,
    imageId,
    name,
  } = product || {};

  const eventDetails = {
    productId: id,
    collectionId: collection,
    imageId,
    productName: name,
    productBrand: brand,
    returnFocus: event.target,
    faceout,
  };

  const prodvm = getProdvmFromDatabridge();

  const baseEvent = {
    eventName: 'quickview:openModal',
    detail: { ...eventDetails, prodvm },
    dispatcher: window,
    analyticsHandler: handleQuickViewClickAnalytics,
  };

  const newEvent = {
    eventName: 'quickview:mfe:openModal',
    detail: {
      ...eventDetails,
      pageViewMethod: 'recommendations',
      productViewMethod: prodvm,
    },
    dispatcher: document,
    analyticsHandler: null,
  };

  const eventToTrigger = isNewQuickviewEnabled ? newEvent : baseEvent;
  const quickviewEvent = new CustomEvent(eventToTrigger.eventName, {
    detail: eventToTrigger.detail,
  });

  // Execute analytics handler if one is configured (legacy mode only)
  eventToTrigger.analyticsHandler?.();

  // Dispatch the event to the appropriate target (document or window)
  eventToTrigger.dispatcher.dispatchEvent(quickviewEvent);
};
